import { toConsumableArray as _toConsumableArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import useMedia from '../../hooks/use-media.esm.js';
import { useSafeThemeUI } from '../../theme-provider/use-theme-ui.esm.js';
import { defaultBreakpoints } from '../../themes/theme-keys/breakpoints.esm.js';
import { get } from '../../utils/object.esm.js';

var SwitchContent = function SwitchContent(_ref) {
  var _ref$breakPoints = _ref.breakPoints,
    breakPoints = _ref$breakPoints === void 0 ? [] : _ref$breakPoints,
    _ref$mediaQuery = _ref.mediaQuery,
    mediaQuery = _ref$mediaQuery === void 0 ? 'min-width' : _ref$mediaQuery,
    replacementContent = _ref.replacementContent,
    children = _ref.children;
  var theme = useSafeThemeUI();
  var _breakpoints = breakPoints.length > 0 ? breakPoints : get(theme, 'breakpoints', defaultBreakpoints);
  var content = [children].concat(_toConsumableArray(replacementContent));
  var _content = [];
  var mediaQueries = [null].concat(_toConsumableArray(_breakpoints.keys.map(_breakpoints.getValueAndUnit))).reduce(function (acc, cur, idx) {
    if (content.length > idx && content[idx]) {
      _content.push(content[idx]);
      return cur ? [].concat(_toConsumableArray(acc), ["(".concat(mediaQuery, ": ").concat(cur, ")")]) : acc;
    }
    return acc;
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, useMedia(mediaQueries.reverse(), _content.reverse(), children));
};

export default SwitchContent;
//# sourceMappingURL=switch-content.esm.js.map
